import React from "react";

export const SvgSpinner = ({ ...props }) => {
	return (
		<svg width="32" height="32" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				opacity="0.3"
				d="M180 90C180 139.706 139.706 180 90 180C40.2944 180 0 139.706 0 90C0 40.2944 40.2944 0 90 0C139.706 0 180 40.2944 180 90ZM28.0635 90C28.0635 124.207 55.7934 151.936 90 151.936C124.207 151.936 151.936 124.207 151.936 90C151.936 55.7934 124.207 28.0635 90 28.0635C55.7934 28.0635 28.0635 55.7934 28.0635 90Z"
				fill="#FFB11A"
			/>
			<path
				d="M165.968 90C173.718 90 180.112 83.6804 178.908 76.0249C177.807 69.0153 175.877 62.1443 173.149 55.5585C168.626 44.6392 161.997 34.7177 153.64 26.3604C145.282 18.0031 135.361 11.3738 124.442 6.85084C117.856 4.1229 110.985 2.19344 103.975 1.09164C96.3196 -0.111707 90 6.28223 90 14.0318V14.0318C90 21.7813 96.3606 27.9055 103.912 29.6462C107.249 30.4153 110.524 31.4616 113.702 32.7782C121.217 35.8908 128.044 40.453 133.796 46.2043C139.547 51.9556 144.109 58.7835 147.222 66.2979C148.538 69.4763 149.585 72.7512 150.354 76.0879C152.094 83.6394 158.219 90 165.968 90V90Z"
				fill="#FFB11A"
			/>
		</svg>
	);
};
